
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_1woeg_141",
  "wizard": "awsui_wizard_1xupv_1woeg_176",
  "refresh": "awsui_refresh_1xupv_1woeg_176",
  "small-container": "awsui_small-container_1xupv_1woeg_183",
  "navigation": "awsui_navigation_1xupv_1woeg_192",
  "number": "awsui_number_1xupv_1woeg_226",
  "circle": "awsui_circle_1xupv_1woeg_242",
  "title": "awsui_title_1xupv_1woeg_253",
  "active": "awsui_active_1xupv_1woeg_284",
  "disabled": "awsui_disabled_1xupv_1woeg_295",
  "enabled": "awsui_enabled_1xupv_1woeg_305",
  "form": "awsui_form_1xupv_1woeg_349",
  "form-header": "awsui_form-header_1xupv_1woeg_354",
  "form-header-content": "awsui_form-header-content_1xupv_1woeg_370",
  "form-component": "awsui_form-component_1xupv_1woeg_374",
  "hidden": "awsui_hidden_1xupv_1woeg_388",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_1woeg_392",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_1woeg_397",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_1woeg_401",
  "form-header-component": "awsui_form-header-component_1xupv_1woeg_401",
  "navigation-link": "awsui_navigation-link_1xupv_1woeg_417",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_1woeg_418",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_1woeg_419",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_1woeg_423",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_1woeg_428",
  "cancel-button": "awsui_cancel-button_1xupv_1woeg_432",
  "previous-button": "awsui_previous-button_1xupv_1woeg_433",
  "primary-button": "awsui_primary-button_1xupv_1woeg_434",
  "skip-to-button": "awsui_skip-to-button_1xupv_1woeg_435",
  "action-buttons": "awsui_action-buttons_1xupv_1woeg_439"
};
  